import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useDropdown } from 'components/UI/V3/Dropdown/DropdownContext';
import styles from 'components/UI/V3/Dropdown/Item/DropdownItem.module.scss';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { Radio } from 'components/UI/V3/Forms/Radio';
import React from 'react';

interface DropdownItemProps {
    type?: 'checkbox' | 'radio';
    checked?: boolean;
    leftIcon?: IconProp;
    rightIcon?: IconProp;
    disabled?: boolean;
    children?: React.ReactNode;
    className?: string;
    onSelect?: (selected: boolean) => void;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
    type,
    checked,
    leftIcon,
    rightIcon,
    disabled,
    children,
    className,
    onSelect
}) => {
    const { setOpen } = useDropdown();

    const clickHandler = React.useCallback(() => {
        onSelect?.(!checked);

        if (onSelect && type !== 'checkbox') {
            setOpen(false);
        }
    }, [checked, onSelect]);

    return (
        <div
            className={clsx(styles.root, className, {
                [styles.disabled]: disabled,
                [styles.hasCheckbox]: type === 'checkbox'
            })}
            onClick={clickHandler}
        >
            {onSelect && (
                <>
                    {type === 'checkbox' && (
                        <Checkbox
                            checked={checked}
                            onChange={onSelect}
                        />
                    )}

                    {type === 'radio' && (
                        <Radio
                            checked={checked}
                            onChange={onSelect}
                        />
                    )}
                </>
            )}

            {leftIcon && <FontAwesomeIcon icon={leftIcon} />}

            <span className={styles.label}>{children}</span>

            {rightIcon && <FontAwesomeIcon icon={rightIcon} />}
        </div>
    );
};
